// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__Lvviu","carousel_header":"Carousel_carousel_header__FtFJz","badge":"Carousel_badge__72kJq","carousel_body":"Carousel_carousel_body__2NDPC"};